var v=function(r){return r.SHAVED="shaved",r.UNSHAVED="unshaved",r.PART_SHAVED="part_shaved",r}({});export{v as IntimaZone};